export const GROCERY_WIZARD_TABS = ['Basic', 'Pricing & Stock', 'Supply & Alerts', 'Availability', 'Media', 'Settings'] as const;

export interface GroceryAvailabilityRow {
  day: string;
  startTime: string;
  endTime: string;
}

export interface GroceryWizardState {
  storeId: string;
  name: string;
  sku: string;
  categoryCode: string;
  subCategoryCode: string;
  brandCode: string;
  variantCode: string;
  weightTypeCode: string;
  warehouseCode: string;
  supplierCode: string;
  stockAlertCode: string;
  price: number;
  discountedPrice: number;
  stock: number;
  unit: string;
  taxGroupCode: string;
  image: string;
  galleryImages: string[];
  availabilitySchedule: GroceryAvailabilityRow[];
  scheduleAvailability: boolean;
  allowSubstitute: boolean;
  description: string;
  isActive: boolean;
}

export function emptyGroceryWizard(storeId = ''): GroceryWizardState {
  return {
    storeId,
    name: '',
    sku: '',
    categoryCode: '',
    subCategoryCode: '',
    brandCode: '',
    variantCode: '',
    weightTypeCode: 'piece',
    warehouseCode: '',
    supplierCode: '',
    stockAlertCode: 'low',
    price: 0,
    discountedPrice: 0,
    stock: 0,
    unit: 'pcs',
    taxGroupCode: '',
    image: '',
    galleryImages: [],
    availabilitySchedule: [],
    scheduleAvailability: false,
    allowSubstitute: true,
    description: '',
    isActive: true,
  };
}

export function productToWizard(product: Record<string, unknown>, storeId: string): GroceryWizardState {
  const meta = (product.metadata || {}) as Record<string, unknown>;
  return {
    storeId,
    name: String(product.name || ''),
    sku: String(product.sku || ''),
    categoryCode: String(meta.categoryCode || product.category || ''),
    subCategoryCode: String(meta.subCategoryCode || ''),
    brandCode: String(meta.brandCode || product.brand || ''),
    variantCode: String(meta.variantCode || ''),
    weightTypeCode: String(meta.weightTypeCode || 'piece'),
    warehouseCode: String(meta.warehouseCode || ''),
    supplierCode: String(meta.supplierCode || ''),
    stockAlertCode: String(meta.stockAlertCode || 'low'),
    price: Number(product.price || 0),
    discountedPrice: Number(product.discountedPrice || 0),
    stock: Number(product.stock || 0),
    unit: String(product.unit || 'pcs'),
    taxGroupCode: String(meta.taxGroupCode || ''),
    image: String(product.image || ''),
    galleryImages: (meta.galleryImages as string[]) || [],
    availabilitySchedule: (meta.availabilitySchedule as GroceryAvailabilityRow[]) || [],
    scheduleAvailability: Boolean(meta.scheduleAvailability),
    allowSubstitute: product.allowSubstitute !== false,
    description: String(product.description || ''),
    isActive: product.isActive !== false,
  };
}

export function wizardToProductPayload(form: GroceryWizardState) {
  const sku = form.sku || form.name.slice(0, 12).toUpperCase().replace(/\s/g, '_');
  return {
    name: form.name,
    sku,
    brand: form.brandCode,
    category: form.categoryCode,
    price: Number(form.price),
    discountedPrice: form.discountedPrice > 0 ? Number(form.discountedPrice) : undefined,
    stock: Number(form.stock),
    unit: form.unit,
    image: form.image || undefined,
    description: form.description || undefined,
    allowSubstitute: form.allowSubstitute,
    isActive: form.isActive,
    metadata: {
      categoryCode: form.categoryCode,
      subCategoryCode: form.subCategoryCode,
      brandCode: form.brandCode,
      variantCode: form.variantCode,
      weightTypeCode: form.weightTypeCode,
      taxGroupCode: form.taxGroupCode,
      warehouseCode: form.warehouseCode,
      supplierCode: form.supplierCode,
      stockAlertCode: form.stockAlertCode,
      galleryImages: form.galleryImages.filter(Boolean),
      availabilitySchedule: form.scheduleAvailability ? form.availabilitySchedule : [],
      scheduleAvailability: form.scheduleAvailability,
    },
  };
}
